import { FC, PropsWithChildren } from "react";
import styles from "./SubmitBar.module.css";

const SubmitBar: FC<PropsWithChildren> = ({ children }: PropsWithChildren) => (
  <div className={styles.buttons}>{children}</div>
);

export default SubmitBar;
